import { render } from "./ButtonPoints.vue?vue&type=template&id=56f7cb99"
const script = {}

import "./ButtonPoints.vue?vue&type=style&index=0&id=56f7cb99&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__